import { resolveApiUrl } from "~/utils/url/urlResolver";
import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";
import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import type { ProductData } from "~/domains/product/types/ProductData";

type ResponseType = Pick<
  ProductDataDTO,
  | "designation"
  | "sapMaterialNumber"
  | "aliases"
  | "shortDescription"
  | "preferred"
  | "url"
  | "images"
  | "manufacturerLogoUrl"
  | "code"
  | "productAllCategories"
  | "quantityVisible"
>[];

export async function fetchTopsellerProducts(productCode: string): Promise<ProductData[]> {
  const url = resolveApiUrl(`/p/${productCode}/topseller`);

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (response.redirected) {
    window.location.reload();
  } else if (response.ok) {
    const data: ResponseType = await response.json();
    return data.map((product) => transformProduct(product as ProductDataDTO));
  }
  throw new Error("Error fetching data");
}
